import {Button, Input, Layout, Modal, Select, Form, Tabs} from 'antd';

import {useEffect, useState} from 'react';
import {PlusOutlined} from '@ant-design/icons';
import {useAppDispatch, useAppSelector} from '../../../../common/hooks';
import {rolesList, addRole, totalPermissions} from './rolesSlice';
import EmpList from './RoleEmployeeList';
const Roles = () => {
  const {Content} = Layout;
  const permissionGroups = useAppSelector((state) => state.roles);
  const permissionsOption = useAppSelector((state) => state.roles.totalPermissions);
  const userPermission = useAppSelector((state) => state.config.config.permissions);
  const dispatch = useAppDispatch();
  const [addGroupModelOpen, setAddGroupModelOpen] = useState(false);
  const [key, setKey] = useState('0');
  const [addRoleForm] = Form.useForm();
  const {Option} = Select;

  useEffect(() => {
    dispatch(rolesList())
      .unwrap()
      .then(() => {
        setKey(permissionGroups.groups[0]?.name);
      });
    dispatch(totalPermissions());

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const handleAddGroup = (values: {name: string; permissions: string[]}) => {
    dispatch(addRole(values))
      .unwrap()
      .then(() => {
        addRoleForm.resetFields();
        setAddGroupModelOpen(false);
        dispatch(rolesList());
      });
  };

  return (
    <>
      <Content style={{background: '#ffffff', height: '100%'}} className='vertical-tabs'>
        <Tabs
          activeKey={key}
          destroyInactiveTabPane
          tabBarExtraContent={
            userPermission.add_permissiongroup ? (
              <Button
                icon={<PlusOutlined />}
                type='primary'
                style={{marginRight: '8px'}}
                onClick={() => {
                  setAddGroupModelOpen(true);
                }}
              >
                Add Role
              </Button>
            ) : null
          }
          onChange={(x) => {
            setKey(x);
          }}
          tabPosition={'left'}
          style={{height: '100%', width: '100%'}}
          items={permissionGroups.groups.map((x) => {
            return {
              label: `${x.name}`,
              key: `${x.name}`,
              children: <EmpList group={x} key={x.id} />,
            };
          })}
        />
      </Content>
      <Modal
        title='Add Role'
        open={addGroupModelOpen}
        onCancel={() => {
          setAddGroupModelOpen(false);
        }}
        okText={'Add'}
        confirmLoading={permissionGroups.isLoading}
        maskClosable={false}
        style={{height: '700px', width: '800px'}}
        onOk={() => {
          addRoleForm
            .validateFields()
            .then((values) => {
              handleAddGroup(values);
            })
            .catch((info) => {
              console.error('Validate Failed:', info);
            });
        }}
      >
        <Form
          form={addRoleForm}
          name='Edit User'
          labelCol={{span: 5}}
          wrapperCol={{span: 19}}
          layout='horizontal'
        >
          <Form.Item
            label='Name'
            name='name'
            rules={[
              {required: true, message: 'Please enter a name'},
              {min: 4, message: 'Atleast 4 characters are required'},
            ]}
          >
            <Input autoComplete='off' placeholder='Role Name' />
          </Form.Item>
          <Form.Item
            label='Permissions'
            name='permissions'
            rules={[{required: true, message: 'At least one pemission is required'}]}
          >
            <Select
              mode='multiple'
              allowClear
              style={{width: '100%'}}
              placeholder='Please select'
              listHeight={200}
            >
              {permissionsOption.map((x, i) => (
                <Option key={i} value={x}>
                  {x}
                </Option>
              ))}
            </Select>
          </Form.Item>
        </Form>
      </Modal>
    </>
  );
};

export default Roles;
